import * as setupLoaderTypes from './setupLoaderActionType';

const initialState = {
    loadingStatus: 0, //-- 0 : init / 1 : Loading / 2 : Loaded
    setupError : false,
    errorMessage: '',
    errorCode: 0
};

const setupInProgress = (state, action) => {
    return {
        ...state,
        loadingStatus: 1,
    }
};

const setupSuccess = (state, action) => {
    return {
        ...state,
        loadingStatus: 2,
        setupError : false,
        errorMessage: '',
        errorCode: 0
    }
};

const setupFailed = (state, action) => {
    const { errorCode, errorMessage } = action;
    return {
        ...state,
        loadingStatus: 2,
        setupError: true,
        errorMessage,
        errorCode
    }
};

export const setup = ( state = initialState, action ) => {
    switch ( action.type ) {   
        case setupLoaderTypes.SETUP_IN_PROGRESS:        return setupInProgress(state, action);
        case setupLoaderTypes.SETUP_SUCCESS:            return setupSuccess(state, action);
        case setupLoaderTypes.SETUP_FAILED:             return setupFailed(state, action);
        default: return state;
    }
};

export default setup;


// WEBPACK FOOTER //
// ./src/components/SetupLoader/setupLoaderReducers.js